import NextImage from "next/image";
import ThumborJS from "thumborjs";
import Link from "next/link";
const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

const App = ({ content, queryParam }) => {
  const myLoader = ({ src, width }) => {
    if (src.split("?")?.length > 1) {
      return `${src}`;
    } else {
      const tugen = new ThumborJS(thumborUrl, thumborKey);
      const url = tugen
        .imgpath(src)
        .resize(width, 0)
        .filter("format(webp)")
        .genurl();

      return url;
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center">
      {content?.map((content, index) => {
        const image_path = content?.image_path?.replace(/\/uploads/g, "");
        const imageProduct = content?.image_path
          ? `${imageUrl}${image_path}`
          : content?.image_path
          ? content?.image_path
          : `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/images/thumbnail.jpg`;
        return (
          <Link
            key={`content1-${index}`}
            prefetch={false}
            href={`${content?.url}${queryParam ? `?${queryParam}` : ``}`}
          >
            <div className="card-firstContent">
              <div className="relative w-full aspect-[1/1]">
                <NextImage
                  loader={myLoader}
                  src={imageProduct}
                  alt={content?.title}
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  placeholder="blur"
                  blurDataURL={`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=`}
                />
              </div>
              <div className="body">
                <p className="h2 title">{`${content?.title}`}</p>
                <p className="h5 desc">Shop Now</p>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default App;
